import { render, staticRenderFns } from "./textEndNew.vue?vue&type=template&id=228c0468&"
import script from "./textEndNew.vue?vue&type=script&lang=ts&"
export * from "./textEndNew.vue?vue&type=script&lang=ts&"
import style0 from "./textEndNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports